/** AuthBranch branch */
export const AUTH = '/auth'
/** AuthBranch routes */
export const LOGIN = `${AUTH}/login`
export const FORBIDDEN = `${AUTH}/forbidden`
export const FORGOT_PASSWORD = `${AUTH}/forgot`
export const UNVERIFIED_EMAIL = `${AUTH}/unverifiedEmail`
export const SSO = `${AUTH}/sso`
export const SSO_ENTRY = `${AUTH}/sso/tokens`
export const PASSWORD = `${AUTH}/password`
export const PENDING_CONFIRMATION = `${AUTH}/pendingConfirmation`
export const PENDING_IDP = `${AUTH}/pendingIdp`
export const RESET_PASSWORD = `${AUTH}/resetPassword/:resetToken`
export const PASSWORD_CREATED = `${AUTH}/passwordCreated`
export const GENERATE_MFA = `${AUTH}/mfa`
export const VERIFY_MFA = `${AUTH}/mfa/verify`

/** Dashboard routes */
export const DASHBOARD = '/'
export const DASHBOARD_SCHEDULE_V1 = `/schedule-v1`
export const DASHBOARD_SCHEDULE = `/schedule`
export const DASHBOARD_QUEUE = `/queue`
export const DASHBOARD_MEMBERS = `/members`
export const DASHBOARD_VISITS = `/visits`
export const DASHBOARD_PASTVISITS = `/pastvisits`
export const DASHBOARD_POLICIES = `/policies`
export const DASHBOARD_PAYMENTS = `/payments`
export const DASHBOARD_REPORTS = `/reports`

/** Help Center route */
export const HELP_CENTER = `/help`

/** Visit routes */
export const PENDING_VISIT_VIEW = '/visits/pending/:pendingVisitId'
export const VISIT_VIEW = '/visits/:visitId/:visitTab?'
export const VISIT_VIDEO_VIEW = '/visits/:visitId/video'
export const VISIT_RATING_VIEW = '/visits/:visitId/rating'

/** Account routes */
export const ACCOUNT = '/account'
export const ACCOUNT_GENERAL = `${ACCOUNT}/general`
export const ACCOUNT_HISTORY = `${ACCOUNT}/history`
export const ACCOUNT_SECURITY = `${ACCOUNT}/security`
export const ACCOUNT_CHANGE_PASSWORD = `${ACCOUNT}/changepassword`

export const RX_CHANGE_REQUEST = '/rxchanges'
